import { Children, isValidElement, ReactElement, ReactNode } from 'react';
import { MenuLink } from './MenuLink';

type MenuLinkProps = {
  path: string;
  children?: ReactNode;
};
// Basic matcher to check if path matches static or dynamic route
const matchPath = (pattern: any, pathname: any): boolean => {
  const patternParts = pattern?.split('/').filter(Boolean);
  const pathParts: any = pathname?.split('/').filter(Boolean);

  if (patternParts.length !== pathParts?.length) return false;

  return patternParts.every((part: any, idx: any) => {
    return part.startsWith('[') || part.startsWith(':') || part === pathParts?.[idx];
  });
};

export const getMenuLinkPath = (children: ReactNode): string => {
  let path = '';

  Children.forEach(children, (child) => {
    if (isValidElement(child) && child.type === MenuLink) {
      const element = child as ReactElement<MenuLinkProps>;
      path = element.props.path;
    }
  });

  return path;
};
export const hasMenuActiveChild = (currentPath: string, children: ReactNode): boolean => {
  const childrenArray: ReactNode[] = Children.toArray(children);

  for (const child of childrenArray) {
    if (isValidElement(child)) {
      const { path, children: nestedChildren } = (child as ReactElement<MenuLinkProps>).props;

      if (child.type === MenuLink && path) {
        if (currentPath === '/') {
          if (path === '/') return true;
        } else if (matchPath(path, currentPath)) {
          return true;
        }
      }

      // Recursively check nested children
      if (nestedChildren && hasMenuActiveChild(currentPath, nestedChildren)) {
        return true;
      }
    }
  }

  return false;
};
